import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { HorizontalSidebarData } from "../../data/json/horizontalSidebar";
import Swal from "sweetalert2";
import axios from "axios";
import useApi from "../../customhook/useApi";
import Loader from "../selfLoder";
import { employee_photo } from "../../../environment";
type PasswordField = "password";

const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const Location = useLocation();
  const sidebarToggleRef = useRef<HTMLAnchorElement>(null);

  type PasswordField = "cpassword" | "npassword" | "ncpassword";
  const [passwordVisibility, setPasswordVisibility] = useState({
    cpassword: false,
    npassword: false,
    ncpassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => { });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => { });
        }
        setIsFullscreen(false);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const { callApi, loading, error, data } = useApi("/api/change-password", {
    method: "POST",
    autoCall: false,
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "New password and confirm password do not match.",
      });
      return;
    }

    try {
      const response = await callApi({
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });
      Swal.fire({
        icon: "success",
        title: "Password Changed",
        text:
          response?.data?.message ||
          "Your password has been updated successfully.",
      });
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err.response?.data?.message ||
          err.message ||
          "Something went wrong, please try again.",
      });
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const sidebar = document.querySelector(".sidebar"); // Adjust class name if different
      if (
        mobileSidebar &&
        sidebar &&
        !sidebar.contains(event.target as Node) &&
        !sidebarToggleRef.current?.contains(event.target as Node)
      ) {
        dispatch(setMobileSidebar(false));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileSidebar]);

  const logout = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("token");
    localStorage.removeItem("employee_name");
    localStorage.removeItem("employee_id");
    localStorage.removeItem("employee_email");
    localStorage.removeItem("menuOpened");
    localStorage.removeItem("employee_photo");
    localStorage.removeItem("is_manager");
    localStorage.removeItem("menuOpened");
    localStorage.removeItem("is_exclusions");
    localStorage.removeItem("skip_manager");
    localStorage.removeItem("is_hod");
    localStorage.removeItem("manager_pms");
    localStorage.removeItem("isMasterLogin");
    // localStorage.clear();
    window.location.reload();
    navigate(routes.login);
  };

  const employee_photo = localStorage.getItem("employee_photo");
  const photoToShow =
    employee_photo && employee_photo !== "null"
      ? employee_photo
      : "./assets/img/logo/profilepic.jpg";

  return (
    <>
      <Loader loading={loading} />
      {/* Header */}
      <div className="header">
        <div className="main-header">
          <div className="header-left">
            <Link to={routes.adminDashboard} className="logo">
              <ImageWithBasePath
                src="/assets/img/logo/weconnectlogo.png"
                alt="Logo"
              />
            </Link>
            <Link to={routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Logo" />
            </Link>
          </div>

          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
            // ref={sidebarToggleRef}
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              >
                <Link
                  id="toggle_btn"
                  to="#"
                  onClick={handleToggleMiniSidebar}
                  className="btn btn-menubar me-1"
                >
                  <i className="ti ti-arrow-bar-to-left"></i>
                </Link>
              </div>

              <div
                className="sidebar sidebar-horizontal"
                id="horizontal-single"
              >
                <div className="sidebar-menu mb-5">
                  <div className="main-menu">
                    <ul className="nav-menu ">
                      <li className="menu-title">
                        <span>Main</span>
                      </li>

                      {HorizontalSidebarData?.map((mainMenu, index) => (
                        <React.Fragment key={`main-${index}`}>
                          {mainMenu?.menu?.map((data, i) => (
                            <li className="submenu" key={`menu-${i}`}>
                              <Link
                                to="#"
                                className={`
														${data?.subMenus
                                    ?.map((link: any) => link?.route)
                                    .includes(Location.pathname)
                                    ? "active"
                                    : ""
                                  } ${subOpen === data.menuValue ? "subdrop" : ""}`}
                              // onClick={() => toggleSidebar(data.menuValue)}
                              >
                                <i className={`ti ti-${data.icon}`}></i>
                                <span>{data.menuValue}</span>
                                <span className="menu-arrow"></span>
                              </Link>

                              {/* First-level Submenus */}
                              <ul
                                style={{
                                  display:
                                    subOpen === data.menuValue
                                      ? "block"
                                      : "none",
                                }}
                              >
                                {data?.subMenus?.map((subMenu: any, j) => (
                                  <li
                                    key={`submenu-${j}`}
                                    className={
                                      subMenu?.customSubmenuTwo ? "submenu" : ""
                                    }
                                  >
                                    <Link
                                      to={subMenu?.route || "#"}
                                      className={`${subMenu?.subMenusTwo
                                        ?.map((link: any) => link?.route)
                                        .includes(Location.pathname) ||
                                        subMenu?.route === Location.pathname
                                        ? "active"
                                        : ""
                                        } ${subsidebar === subMenu.menuValue
                                          ? "subdrop"
                                          : ""
                                        }`}
                                      onClick={() => {
                                        toggleSubsidebar(subMenu.menuValue);
                                      }}
                                    >
                                      <span>{subMenu?.menuValue}</span>
                                      {subMenu?.customSubmenuTwo && (
                                        <span className="menu-arrow"></span>
                                      )}
                                    </Link>

                                    {/* Check if `customSubmenuTwo` exists */}
                                    {subMenu?.customSubmenuTwo &&
                                      subMenu?.subMenusTwo && (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === subMenu.menuValue
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {subMenu.subMenusTwo.map(
                                            (subMenuTwo: any, k: number) => (
                                              <li key={`submenu-two-${k}`}>
                                                <Link
                                                  className={
                                                    subMenuTwo.route ===
                                                      Location.pathname
                                                      ? "active"
                                                      : ""
                                                  }
                                                  to={subMenuTwo.route}
                                                >
                                                  {subMenuTwo.menuValue}
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      )}
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ))}
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <div className="dropdown profile-dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <span className="avatar avatar-sm online">
                      <ImageWithBasePath
                        src={photoToShow}
                        alt="Img"
                        className="img-fluid rounded-circle"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu shadow-none">
                    <div className="card mb-0">
                      <div className="card-header">
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-lg me-2 avatar-rounded">
                            <ImageWithBasePath src={photoToShow} alt="img" />
                          </span>
                          <div>
                            <h5 className="mb-0">
                              {localStorage.getItem("employee_name")}
                            </h5>
                            <p className="fs-12 fw-medium mb-0">
                              {localStorage.getItem("employee_email")}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0"
                          to={routes.profile}
                        >
                          <i className="ti ti-user-circle me-1"></i>My Profile
                        </Link>
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={routes.communication}
                        >
                          <i className="ti ti-user-plus me-1"></i>Onboarding
                        </Link>
                        <button
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          data-bs-target="#changePasswordModal"
                          data-bs-toggle="modal"
                        >
                          <i className="ti ti-lock me-1"></i>Change Password
                        </button>
                      </div>
                      <div className="card-footer">
                        <button
                          className="dropdown-item d-inline-flex align-items-center p-0"
                          onClick={logout}
                        >
                          <i className="ti ti-login me-2"></i>Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to={routes.profile}>
                <i className="ti ti-user-circle me-1"></i> My Profile
              </Link>
              {/* <Link className="dropdown-item" to={routes.communication}>
                <i className="ti ti-user-plus me-1"></i>On Boarding
              </Link> */}
              <Link
                to="#"
                className="dropdown-item"
                data-bs-target="#changePasswordModal"
                data-bs-toggle="modal"
              >
                <i className="ti ti-lock me-1"></i>Change Password
              </Link>

              <button className="dropdown-item" onClick={logout}>
                <i className="ti ti-login me-2"></i> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Header */}

      <div
        className="modal fade"
        id="changePasswordModal"
        tabIndex={-1}
        aria-labelledby="changePasswordModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="changePasswordModalLabel">
                Change Password
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form id="changePasswordForm" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Current Password</label>
                  <div className="pass-group">
                    <input
                      type={passwordVisibility.cpassword ? "text" : "password"}
                      className="pass-input form-control"
                      name="currentPassword"
                      value={formData.currentPassword}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className={`ti toggle-passwords ${passwordVisibility.cpassword ? "ti-eye" : "ti-eye-off"
                        }`}
                      onClick={() => togglePasswordVisibility("cpassword")}
                      style={{ cursor: "pointer" }}
                    ></span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <div className="pass-group">
                    <input
                      type={passwordVisibility.npassword ? "text" : "password"}
                      className="pass-input form-control"
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className={`ti toggle-passwords ${passwordVisibility.npassword ? "ti-eye" : "ti-eye-off"
                        }`}
                      onClick={() => togglePasswordVisibility("npassword")}
                      style={{ cursor: "pointer" }}
                    ></span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Confirm Password</label>
                  <div className="pass-group">
                    <input
                      type={passwordVisibility.ncpassword ? "text" : "password"}
                      className="pass-input form-control"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className={`ti toggle-passwords ${passwordVisibility.ncpassword ? "ti-eye" : "ti-eye-off"
                        }`}
                      onClick={() => togglePasswordVisibility("ncpassword")}
                      style={{ cursor: "pointer" }}
                    ></span>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="submit"
                form="changePasswordForm"
                className="btn btn-primary custom_button"
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
